import React, { useState, useEffect } from "react";
import cam from "../Assets/camera-svgrepo-com (2) 2.png";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import pro from '../Assets/image121252.png'
import img1 from '../Assets/1721270706-bpfull 711.png'
import heart from "../Assets/hear.png";
import img from "../Assets/1721270706-bpfull 8.png";
import serch from '../Assets/Vector.png'
import Shop from "../Components/Shop";
import { toast } from "react-toastify";
import { apiDelete, apiGet, apiPost, formatDate, formatDateonly, formatTimeOnly } from "../ApiUrls";
import { useNavigate } from "react-router-dom";
import ContentLoader from "react-content-loader"
import Edit from '../Assets/Edit.svg'
import UpdateGallaryModal from "../Components/UpdateGallaryModal";
import UpdateAboutModal from "../Components/UpdateAboutModal";
import UpdateAvailableForModal from "../Components/UpdateAvailableForModal";
import UpdatePersonalDetailModal from "../Components/UpdatePersonalDetailModal";
import UpdateAvailableModal from "../Components/UpdateAvailableModal";
import UpdateUserModel from "../Components/UpdateUserModel";
import UserChatModal from "../Components/UserChatModal";
import HostessChatModel from "../Components/HostessChatModel";
import icon from '../Assets/image121252.png'
import { FaInstagram, FaTelegram, FaLinkedin, FaGlobe, FaFacebook } from "react-icons/fa";
import UpdateProfileImageModal from "../Components/UpdateProfileImageModal";
import UpdateSocialMedialinkModal from "../Components/UpdateSocialMedialinkModal";
import UpdateUserSocialMedialinkModel from "../Components/UpdateUserSocialMedialinkModel";
import UpdateUserProfileModal from "../Components/UpdateUserProfileModal";
import SEOData from "../Components/SEOData";

function Profile() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const [IsLogin, setsetIsLogin] = useState(false);

  useEffect(() => {
    const dataToken = localStorage.getItem("userToken");
    if (dataToken) {
      setsetIsLogin(true);
    } else {
      setsetIsLogin(false);
    }
  }, []);

  const [IsUser, setIsUser] = useState(false);
  const [IsHostess, setIsHostess] = useState(false);

  useEffect(() => {
    const userType = JSON.parse(localStorage.getItem("userType"));

    if (userType === "User") {
      setIsUser(true);
    }
    if (userType === "Hostess") {
      setIsHostess(true);
    }
  }, []);


  const Logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userType');
    localStorage.removeItem('userid');
    localStorage.removeItem('userToken');
    toast.success('Logged out successfully!');
    navigate('/');
    window.location.reload();
  };


  //User apis

  const [UserProfile, setUserProfile] = useState({});

  const [AllSubscribedHostess, setAllSubscribedHostess] = useState([]);
  const [AllChatedhostess, setAllChatedhostess] = useState([]);
  const [AllLikedHostess, setAllLikedHostess] = useState([]);

  const GetUserProfile = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/user/GetUserProfile`);
      setUserProfile(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  const GetSubscribedHostess = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/user/GetAllSubscribedHostess`);
      setAllSubscribedHostess(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };
  const GetLikedHostess = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/user/GetAllLikedHostess`);
      setAllLikedHostess(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  const GetChattedHosstess = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/user/GetAllthecontactofuser`);
      setAllChatedhostess(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };




  //Hostess Apis


  const [AllReview, setAllReview] = useState([]);
  const [HostessProfile, setHostessProfile] = useState({});
  const [AllSubscribedUser, setAllSubscribedUser] = useState([]);
  const [AllChatedUser, setAllChatedUser] = useState([]);
  const [AllLastViews, setAllLastViews] = useState([]);
  const [IsUploading, setIsUploading] = useState(false);

  const GetHostessProfile = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/hostess/GetHostessProfile`);
      setHostessProfile(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };



  const GetAllReview = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/hostess/GetAllReview`);
      setAllReview(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };
  const GetAllsubscriberUsers = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/hostess/GetAllsubscriberUsers`);
      setAllSubscribedUser(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };
  const GetAllChatedUser = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/hostess/GetAllthecontactofHostess`);
      setAllChatedUser(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };
  const GetAllLastViews = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/hostess/GetLastVisitedUsers`);
      setAllLastViews(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  const DeleteReview = async (id) => {
    try {
      setIsUploading(true);
      const response = await apiDelete(`api/hostess/DeleteReview/${id}`);
      toast.success(response?.message);
      setIsUploading(false);
      GetAllReview()
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (IsLogin) {
      if (IsUser) {
        GetUserProfile();
        GetSubscribedHostess();
        GetLikedHostess();
        GetChattedHosstess();
      }
      if (IsHostess) {
        GetHostessProfile();
        GetAllReview();
        GetAllsubscriberUsers();
        GetAllChatedUser();
        GetAllLastViews();
      }
    }
  }, [IsLogin,]);



  const [OpenUpdateGallaryModal, setOpenUpdateGallaryModal] = useState(false);

  const OpenUpdateGallary = () => {
    setOpenUpdateGallaryModal(true)
  }
  const CloseUpdateGallary = () => {
    setOpenUpdateGallaryModal(false)
  }

  const [OpenUpdateProfileImageModal, setOpenUpdateProfileImageModal] = useState(false);

  const OpenUpdateProfileImage = () => {
    setOpenUpdateProfileImageModal(true)
  }
  const CloseUpdateProfileImage = () => {
    setOpenUpdateProfileImageModal(false)
  }


  const [OpenUpdateUserProfileImageModal, setOpenUpdateUserProfileImageModal] = useState(false);

  const OpenUpdateUserProfileImage = () => {
    setOpenUpdateUserProfileImageModal(true)
  }
  const CloseUpdateUserProfileImage = () => {
    setOpenUpdateUserProfileImageModal(false)
  }


  const [OpenUpdateAboutModal, setOpenUpdateAboutModal] = useState(false);

  const OpenUpdateAbout = () => {
    setOpenUpdateAboutModal(true)
  }
  const CloseUpdateAbout = () => {
    setOpenUpdateAboutModal(false)
  }


  const [OpenUpdateAvailableModal, setOpenUpdateAvailableModal] = useState(false);

  const OpenUpdateAvailable = () => {
    setOpenUpdateAvailableModal(true)
  }
  const CloseUpdateAvailable = () => {
    setOpenUpdateAvailableModal(false)
  }

  const [OpenUpdatePersonalModal, setOpenUpdatePersonalModal] = useState(false);

  const OpenUpdatePersonal = () => {
    setOpenUpdatePersonalModal(true)
  }
  const CloseUpdatePersonal = () => {
    setOpenUpdatePersonalModal(false)
  }

  const [OpenAvailableModel, setOpenAvailableModel] = useState(false);


  const OpenAvailableModal = () => {
    setOpenAvailableModel(true)
  }
  const CloseAvailablePersonal = () => {
    setOpenAvailableModel(false)
  }


  const [UpdateModel, setUpdateModel] = useState(false);

  const OpenUpdateModel = () => {
    setUpdateModel(true)
  }

  const CloseUpdatModel = () => {
    setUpdateModel(false)
  }

  const [UpdateUserSocialModel, setUpdateUserSocialModel] = useState(false);

  const OpenUpdateUserSocialModel = () => {
    setUpdateUserSocialModel(true)
  }

  const CloseUpdateUserSocialModel = () => {
    setUpdateUserSocialModel(false)
  }


  const [UserChatmodel, setUserChatmodel] = useState(false);
  const [SelectedHost, setSelectedHost] = useState(null);
  const OpenUserChatModel = (Hostid) => {
    setSelectedHost(Hostid)
    setUserChatmodel(true)
  }
  const OpenUserChatModelfromallHostess = (Hostid) => {
    const {
      Hostess: {
        _id: id,
        ModelType: model,
        UserName: name,
        Email: email,
        Gallary: [profilePicture],
      },
    } = Hostid;

    const formattedData = {
      id,
      model,
      name,
      email,
      profilePicture,
    };
    setSelectedHost(formattedData);
    setUserChatmodel(true);
  };

  const CloseUserChatModel = () => {
    setSelectedHost(null)
    setUserChatmodel(false)
  }

  const [HostessChatmodel, setHostessChatmodel] = useState(false);
  const [SelectedUser, setSelectedUser] = useState(null);

  const OpenHostessChatModel = (userid) => {
    console.log(userid, 'aaa')
    setSelectedUser(userid)
    setHostessChatmodel(true)
  }

  const OpenHostessChatModelfromAllUser = (userid) => {
    const {
      User: {
        _id: id,
        UserName: name,
        Email: email,
        profilePicture = null,
      },
    } = userid;

    const formattedData = {
      id,
      model: 'User',
      name,
      email,
      profilePicture,
    };

    setSelectedUser(formattedData);
    setHostessChatmodel(true);
  };

  const OpenHostessChatModelfromlastView = (userid) => {
    const formattedData = {
      id: userid?._id,
      model: 'User',
      name: userid?.UserName,
      email: userid?.Email,
      profilePicture: null,
    };

    setSelectedUser(formattedData);
    setHostessChatmodel(true);
  };


  const CloseHostessChatModel = () => {
    setSelectedUser(null)
    setHostessChatmodel(false)
  }

  const [searchTerm, setSearchTerm] = useState("");

  const filteredChatList = AllChatedhostess?.filter((item) =>
    item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item?.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );



  const filteredUsers = AllChatedUser?.filter((item) =>
    item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item?.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const ModelDetailPage = (id) => {
    navigate(`/ModelDetail/${id}`)
  }


  const [OldPassword, setOldPassword] = useState('');
  const [NewPassword, setNewPassword] = useState('');

  const HostessChangePassword = async () => {
    if (!OldPassword || !NewPassword) {
      toast.error('Current Password and New Password are required!');
      return;
    }

    if (OldPassword == NewPassword) {
      toast.error('Current Password and New Password are Same!');
      return;
    }

    try {
      let data = {
        Email: HostessProfile?.Email,
        OldPassword,
        NewPassword
      }
      setIsUploading(true)
      const response = await apiPost(`api/hostess/UpdateHostessPassword`, data)
      console.log('User Login Successfull:', response);
      toast.success(response?.message);
      setOldPassword('')
      setNewPassword('')
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }

  const UserChangePassword = async () => {
    if (!OldPassword || !NewPassword) {
      toast.error('Old Password and New Password are required!');
      return;
    }

    if (OldPassword == NewPassword) {
      toast.error('Old Password and New Password are Same!');
      return;
    }

    try {
      let data = {
        Email: UserProfile?.Email,
        OldPassword,
        NewPassword
      }
      setIsUploading(true)
      const response = await apiPost(`api/user/UpdateUserPassword`, data)
      console.log('User Login Successfull:', response);
      toast.success(response?.message);
      setOldPassword('')
      setNewPassword('')
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }

  const [OpenUpdateSocialmediaModal, setOpenUpdateSocialmediaModal] = useState(false);

  const OpenUpdateSocialmedia = () => {
    setOpenUpdateSocialmediaModal(true)
  }
  const CloseUpdateSocialmedia = () => {
    setOpenUpdateSocialmediaModal(false)
  }

  return (
    <>
      <Navbar />
      <SEOData PageName={'profile'} />
      <div className="main-cont">
        <div className="main-cont-left">
          <div className="sidebar">
            <div className="tab-container">
              <div className=" tabs2">
                <button
                  className={activeTab === 1 ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange(1)}
                >
                  Profile
                </button>
                <button
                  className={activeTab === 2 ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange(2)}
                >
                  {IsUser ?
                    "All Subscribed Host"
                    :
                    "All Subscribers Users"
                  }
                </button>

                {IsUser &&
                  <button
                    className={activeTab === 9 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(9)}
                  >
                    All Liked Model
                  </button>
                }
                <button
                  className={activeTab === 3 ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange(3)}
                >
                  Chat List
                </button>
                {IsHostess &&
                  <button
                    className={activeTab === 4 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(4)}
                  >
                    Reviews
                  </button>
                }
                {IsHostess &&
                  <button
                    className={activeTab === 5 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(5)}
                  >
                    Last views
                  </button>
                }
                <button
                  className={activeTab === 6 ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange(6)}
                >
                  Setting
                </button>
                {!IsHostess &&
                  <button
                    className={activeTab === 8 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(8)}
                  >
                    Shop
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="main-cont-right">
          <div className="tab-content">
            {activeTab === 1 && (
              <>
                {IsHostess && (
                  <>
                    {IsUploading ?
                      (
                        <div className="ProfileStatus">
                          <div className="skeleton skeleton-header"></div>
                          <div className="skeleton skeleton-img"></div>
                          <div className="skeleton skeleton-paragraph"></div>
                          <div className="skeleton skeleton-gallery">
                            {Array(3)
                              ?.fill(0)
                              ?.map((_, index) => (
                                <div key={index} className="skeleton skeleton-gallery-item"></div>
                              ))}
                          </div>
                          <div className="skeleton skeleton-paragraph"></div>
                        </div>
                      )
                      :
                      (
                        <div className="ProfileStatus">
                          {/* <h3>Profile Status</h3>
                          <br /> */}
                          <div className="username-img">
                            <img src={HostessProfile?.ProfileImage ? HostessProfile?.ProfileImage : img} />
                            <div className="availability top-left" >
                              <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px', width: '130px' }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: 'white' }}>
                                  <span>{HostessProfile?.MakeAvailable ? "Available" : "UnAvailable"}</span>
                                  <img className="editimage" onClick={OpenAvailableModal} src={Edit} alt="Edit" style={{ cursor: "pointer" }} />
                                </div>
                              </div>
                            </div>
                            <img onClick={OpenUpdateProfileImage} className="Edit top-right" src={Edit} alt="Edit" />
                            <div className="username-name">
                              <p>{HostessProfile?.UserName}</p>
                            </div>
                          </div>
                          <br />
                          <div className="PhotoGallery">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <h2>Photo Gallery</h2>
                              <img onClick={OpenUpdateGallary} src={Edit} alt="Edit" />
                            </div>
                            <br />
                            <div className="PhotoGallery-div">
                              {HostessProfile?.Gallary?.map((image, index) => (
                                <img className="GallaryImage" key={index} src={image} alt={`Gallery Image ${index + 1}`} />
                              ))}
                            </div>
                          </div>
                          <br />
                          <div className="PhotoGallery">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <h2>About Me</h2>
                              <img onClick={OpenUpdateAbout} src={Edit} alt="Edit" />
                            </div>
                            <br />
                            <p>
                              {HostessProfile?.AboutMe}
                            </p>
                          </div>
                          <br />

                          <div className="PhotoGallery">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <h2>Available for</h2>
                              <img onClick={OpenUpdateAvailable} src={Edit} alt="Edit" />
                            </div>
                            <br />
                            <div className="ModelPhoto-div">
                              {HostessProfile?.AvailableFor?.map((item, index) => (
                                <div className="ModelPhoto" key={index}>
                                  <img src={cam} />
                                  <h3>{item}</h3>
                                </div>
                              ))}
                            </div>

                          </div>
                          <br />

                          {/* <div className="PhotoGallery">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <h2>Personality & Hobibes</h2>
                              <img onClick={OpenUpdateAvailable} src={Edit} alt="Edit" />
                            </div>
                            <br />
                            <div className="ModelPhoto-div">
                              {HostessProfile?.PersonalityorHobbies?.map((item, index) => (
                                <div className="ModelPhoto" key={index}>
                                  <h3>{item}</h3>
                                </div>
                              ))}
                            </div>
                          </div>
                          <br /> */}

                          <div className="PhotoGallery">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <h2>Basic Details</h2>
                              <img onClick={OpenUpdatePersonal} src={Edit} alt="Edit" />
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <i class="bi bi-geo-alt"></i>
                              </div>
                              <div>
                                <h5>Country - {HostessProfile?.Country}</h5>
                              </div>
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <i class="bi bi-geo-alt"></i>
                              </div>
                              <div>
                                <h5>State - {HostessProfile?.State}</h5>
                              </div>
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <i class="bi bi-geo-alt"></i>
                              </div>
                              <div>
                                <h5>City - {HostessProfile?.City}</h5>
                              </div>
                            </div>

                          </div>
                          <br />

                          {/* <div className="PhotoGallery">
                            <h2>Visibility</h2>
                            <br />
                            <h4>Visibility of the profile:</h4>
                            <br />
                            <div className="Visibility-radio">

                              <label className='rad-div rad-div2'>
                                <input className='rad' type="radio" name="color" value="Normal" />
                                Normal
                              </label>
                              <br />

                              <label className='rad-div rad-div2'>
                                <input className='rad' type="radio" name="color" value="Private" />
                                Private
                              </label>
                              <br />

                              <label className='rad-div rad-div2'>
                                <input className='rad' type="radio" name="color" value="Pause" />
                                Pause / In Tour
                              </label>
                            </div>
                            <br />
                            <h7>Private: Your profile will be only visible to Users that are logged in</h7>
                            <br />
                            <br />
                            <h7>Tour: Nobody will see your profile in the Search page,  exept users you already talked to in the Chat section</h7>
                            <br />
                            <h4>Notification Preference</h4>
                            <br />
                            <div className="Visibility-radio">
                              <label className='rad-div rad-div2'>
                                <input className='rad' type="radio" name="Email" value="Normal" />
                                Email
                              </label>
                              <br />

                              <label className='rad-div rad-div2'>
                                <input className='rad' type="radio" name="Email" value="Normal+sms" />
                                Email + SMS
                              </label>

                            </div>
                          </div> */}

                          <div className="PhotoGallery">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <h2>Social Media</h2>
                              <img onClick={OpenUpdateSocialmedia} src={Edit} alt="Edit" />
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <FaFacebook style={{ color: "#1877F2", fontSize: "20px" }} />
                              </div>
                              <div>
                                <h5>Facebook - {HostessProfile?.Facebook || 'Not added yet'}</h5>
                              </div>
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <FaInstagram style={{ color: "#E4405F", fontSize: "20px" }} />
                              </div>
                              <div>
                                <h5>Instagram - {HostessProfile?.Instagram || 'Not added yet'}</h5>
                              </div>
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <FaTelegram style={{ color: "#0088CC", fontSize: "20px" }} />
                              </div>
                              <div>
                                <h5>Telegram - {HostessProfile?.Telegram || "Not Added yet"}</h5>
                              </div>
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <FaLinkedin style={{ color: "#0077B5", fontSize: "20px" }} />
                              </div>
                              <div>
                                <h5>LinkedIn - {HostessProfile?.LinkedIn || "Not Added yet"}</h5>
                              </div>
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <FaGlobe style={{ color: "#950952", fontSize: "20px" }} />
                              </div>
                              <div>
                                <h5>Personal Website - {HostessProfile?.PersonalWebsite || "Not Added yet"}</h5>
                              </div>
                            </div>

                          </div>

                          <br />

                          <div className="PhotoGallery">
                            <h2>Contact Details</h2>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <i class="bi bi-telephone"></i>
                              </div>
                              <div>
                                <h3>{HostessProfile?.Number}</h3>
                              </div>
                            </div>
                            <br />
                            <div className="basicdetails">
                              <div className="loc-icon">
                                <i class="bi bi-envelope"></i>
                              </div>
                              <div>
                                <h3>{HostessProfile?.Email}</h3>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div className="PhotoGallery">
                            <h2>Personal Details</h2>
                            <br />
                            <div className="basicdetails">
                              <div>
                                <h5>Name - </h5>
                                <br />
                                <h5>DOB - </h5>
                              </div>
                              <div>
                                <h5>{HostessProfile?.UserName}</h5>
                                <br />
                                <h5>{HostessProfile?.DOB}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                )}
                {IsUser && (
                  <>
                    {IsUploading ? (
                      <div className="ProfileStatus">
                        <div className="skeleton skeleton-header"></div>
                        <div className="skeleton skeleton-img"></div>
                        <div className="skeleton skeleton-paragraph"></div>
                        <div className="skeleton skeleton-gallery">
                          {Array(3)
                            ?.fill(0)
                            ?.map((_, index) => (
                              <div key={index} className="skeleton skeleton-gallery-item"></div>
                            ))}
                        </div>
                        <div className="skeleton skeleton-paragraph"></div>
                      </div>
                    ) : (
                      <div className="ProfileStatus">
                        <h3>Profile Status</h3>
                        <br />
                        <div className="username-img">
                          <img src={UserProfile?.ProfileImage ? UserProfile?.ProfileImage : img} alt="User Avatar" />
                          <div className="username-name">
                            <p>{UserProfile?.UserName}</p>
                          </div>
                          <img onClick={OpenUpdateUserProfileImage} className="Edit top-right" src={Edit} alt="Edit" />
                        </div>
                        <br />
                        <div className="PhotoGallery">
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>Basic Details</h2>
                            <img onClick={OpenUpdateModel} src={Edit} alt="Edit" />
                          </div>
                          <br />
                          <div className="basicdetails">
                            <div className="icon">
                              <i className="bi bi-telephone"></i>
                            </div>
                            <div>
                              <h3>{UserProfile?.Number}</h3>
                            </div>
                          </div>
                          <br />
                          <div className="basicdetails">
                            <div className="icon">
                              <i className="bi bi-envelope"></i>
                            </div>
                            <div>
                              <h3>{UserProfile?.Email}</h3>
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="PhotoGallery">
                          <h2>Personal Details</h2>
                          <br />
                          <div className="basicdetails">
                            <div>
                              <h5>Name - </h5>
                              <br />
                              <h5>DOB - </h5>
                            </div>
                            <div>
                              <h5>{UserProfile?.UserName}</h5>
                              <br />
                              <h5>{UserProfile?.DOB}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="PhotoGallery">
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>Social Media</h2>
                            <img onClick={OpenUpdateUserSocialModel} src={Edit} alt="Edit" />
                          </div>
                          <br />
                          <div className="basicdetails">
                            <div className="loc-icon">
                              <FaFacebook style={{ color: "#1877F2", fontSize: "20px" }} />
                            </div>
                            <div>
                              <h5>Facebook - {UserProfile?.Facebook || 'Not added yet'}</h5>
                            </div>
                          </div>
                          <br />
                          <div className="basicdetails">
                            <div className="loc-icon">
                              <FaInstagram style={{ color: "#E4405F", fontSize: "20px" }} />
                            </div>
                            <div>
                              <h5>Instagram - {UserProfile?.Instagram || 'Not added yet'}</h5>
                            </div>
                          </div>
                          <br />
                          <div className="basicdetails">
                            <div className="loc-icon">
                              <FaTelegram style={{ color: "#0088CC", fontSize: "20px" }} />
                            </div>
                            <div>
                              <h5>Telegram - {UserProfile?.Telegram || "Not Added yet"}</h5>
                            </div>
                          </div>
                          <br />
                          <div className="basicdetails">
                            <div className="loc-icon">
                              <FaLinkedin style={{ color: "#0077B5", fontSize: "20px" }} />
                            </div>
                            <div>
                              <h5>LinkedIn - {UserProfile?.LinkedIn || "Not Added yet"}</h5>
                            </div>
                          </div>
                          <br />
                          <div className="basicdetails">
                            <div className="loc-icon">
                              <FaGlobe style={{ color: "#950952", fontSize: "20px" }} />
                            </div>
                            <div>
                              <h5>Personal Website - {UserProfile?.PersonalWebsite || "Not Added yet"}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            {activeTab === 2 && (
              <>
                {IsHostess && (
                  <div className="ProfileStatus">
                    {IsUploading ? (
                      <ContentLoader
                        speed={2}
                        width={800}
                        height={100}
                        viewBox="0 0 800 100"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                      >
                        <circle cx="50" cy="50" r="30" />
                        <rect x="100" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="100" y="50" rx="5" ry="5" width="60" height="10" />
                        <rect x="200" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="320" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="450" y="25" rx="5" ry="5" width="100" height="15" />
                      </ContentLoader>
                    ) : (
                      AllSubscribedUser?.length > 0 ? (
                        <>
                          <h3>All Subscriber Uses</h3>
                          <br />
                          <div className="PhotoGallery">
                            <h2>Users</h2>
                            <br />
                            {AllSubscribedUser?.map((item, index) => (
                              <div onClick={() => { OpenHostessChatModelfromAllUser(item) }} key={index} className="order-cards">
                                <div className="order-cards-div">
                                  <img src={img1} alt="User" />
                                  <div className="order-name">
                                    <h5>{item?.User?.UserName}</h5>
                                    <h4>
                                      <i className="bi bi-geo-alt"></i>Rs. {item?.Amount}
                                    </h4>
                                    <h4>+91{item?.User?.Number}</h4>
                                    <h4>{item?.User?.Email}</h4>
                                  </div>
                                </div>
                                <div className="Accept-div">
                                  <div className="Accept-btns">
                                  </div>
                                  <h3 className="INPROGRESS">{formatDate(item?.createdAt)}</h3>
                                </div>
                              </div>
                            ))}
                            <br />
                          </div>
                        </>
                      ) : (
                        <div className="NoChatMessage">
                          <h3>No Conversations Found</h3>
                        </div>
                      )
                    )}
                  </div>
                )}
                {IsUser && (
                  <div className="ProfileStatus">
                    {IsUploading ? (
                      <ContentLoader
                        speed={2}
                        width={800}
                        height={100}
                        viewBox="0 0 800 100"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                      >
                        <circle cx="50" cy="50" r="30" />
                        <rect x="100" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="100" y="50" rx="5" ry="5" width="60" height="10" />
                        <rect x="200" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="320" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="450" y="25" rx="5" ry="5" width="100" height="15" />
                      </ContentLoader>
                    ) : (
                      AllSubscribedHostess?.length > 0 ? (
                        <>
                          <h3>All Subscribed Hostess</h3>
                          <br />
                          <div className="PhotoGallery">
                            <h2>Hostess</h2>
                            <br />
                            {AllSubscribedHostess?.map((item, index) => (
                              <div onClick={() => { OpenUserChatModelfromallHostess(item) }} key={index} className="order-cards">
                                <div className="order-cards-div">
                                  <img src={item?.Hostess?.Gallary[0] || img1} alt="Hostess" />
                                  <div className="order-name">
                                    <h5>{item?.Hostess?.UserName}</h5>
                                    <h4>
                                      <i className="bi bi-geo-alt"></i>{item?.Hostess?.City} {item?.Hostess?.State}
                                    </h4>
                                    <h4>Rs. {item?.Hostess?.SubcriptionPrice}</h4>
                                    <h2>
                                      <i className="bi bi-calendar"></i>{formatDate(item?.createdAt)}
                                    </h2>
                                  </div>
                                </div>
                                <div className="Accept-div">
                                  <div className="Accept-btns">
                                    {/* <button className="Accept">Accept</button>
                                    <button className="Denay">Denay</button> */}
                                  </div>
                                  <h3 className="INPROGRESS">IN PROGRESS</h3>
                                </div>
                              </div>
                            ))}
                            <br />
                          </div>
                        </>
                      ) : (
                        <div className="NoChatMessage">
                          <h3>No Subscribed Hostess available.</h3>
                        </div>
                      )
                    )}
                  </div>
                )}

              </>
            )}
            {activeTab === 9 && (
              <>
                {IsUser && (
                  <div className="ProfileStatus">
                    {IsUploading ? (
                      <ContentLoader
                        speed={2}
                        width={800}
                        height={100}
                        viewBox="0 0 800 100"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                      >
                        <circle cx="50" cy="50" r="30" />
                        <rect x="100" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="100" y="50" rx="5" ry="5" width="60" height="10" />
                        <rect x="200" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="320" y="25" rx="5" ry="5" width="100" height="15" />
                        <rect x="450" y="25" rx="5" ry="5" width="100" height="15" />
                      </ContentLoader>
                    ) : (
                      AllLikedHostess?.length > 0 ? (
                        <>
                          <h3>All Liked Hostess</h3>
                          <br />
                          <div className="PhotoGallery">
                            <h2>Hostess</h2>
                            <br />
                            {AllLikedHostess?.map((item, index) => (
                              <div onClick={() => { ModelDetailPage(item?._id) }} key={index} className="order-cards">
                                <div className="order-cards-div">
                                  <img src={item?.Gallary[0] || img1} alt="Hostess" />
                                  <div className="order-name">
                                    <h5>{item?.UserName}</h5>
                                    <h4>
                                      <i className="bi bi-geo-alt"></i>{item?.City} {item?.State}
                                    </h4>
                                    <h4>Rs. {item?.SubcriptionPrice}</h4>
                                    <h2>
                                      <i className="bi bi-calendar"></i>{formatDate(item?.createdAt)}
                                    </h2>
                                  </div>
                                </div>
                                <div className="Accept-div">
                                  <div className="Accept-btns">
                                    {/* <button className="Accept">Accept</button>
                                    <button className="Denay">Denay</button> */}
                                  </div>
                                  <h3 className="INPROGRESS">IN PROGRESS</h3>
                                </div>
                              </div>
                            ))}
                            <br />
                          </div>
                        </>
                      ) : (
                        <div className="NoChatMessage">
                          <h3>No Subscribed Hostess available.</h3>
                        </div>
                      )
                    )}
                  </div>
                )}

              </>
            )}

            {activeTab === 3 && <>
              {IsUser && (
                <div className="ProfileStatus">
                  {IsUploading ? (
                    <ContentLoader
                      speed={2}
                      width={800}
                      height={100}
                      viewBox="0 0 800 100"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <circle cx="50" cy="50" r="30" />
                      <rect x="100" y="25" rx="5" ry="5" width="100" height="15" />
                      <rect x="100" y="50" rx="5" ry="5" width="60" height="10" />
                      <rect x="200" y="25" rx="5" ry="5" width="100" height="15" />
                      <rect x="320" y="25" rx="5" ry="5" width="100" height="15" />
                      <rect x="450" y="25" rx="5" ry="5" width="100" height="15" />
                    </ContentLoader>
                  ) : (
                    AllChatedhostess?.length > 0 ? (
                      <>
                        <h3>Chat List</h3>
                        <br />
                        <div className="ChatList">
                          <div className="ChatList-search">
                            <input
                              placeholder="Search Conversation"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <img src={serch} alt="Search" />
                          </div>
                          <br />
                          <br />
                          <div className="chat-container">
                            {filteredChatList?.map((item, index) => (
                              <div
                                onClick={() => {
                                  OpenUserChatModel(item);
                                }}
                                className="chat-div"
                                key={index}
                              >
                                <div className="chat-div-1">
                                  <div>
                                    <img
                                      src={item?.profilePicture ? item?.profilePicture : pro}
                                      alt="Profile"
                                    />
                                  </div>
                                  <div>
                                    <h3>{item?.name}</h3>
                                    <p>{item?.email}</p>
                                  </div>
                                </div>
                                <div className="chat-time">
                                  <h4>{item?.time || "9:00 PM"}</h4>
                                </div>
                              </div>
                            ))}
                            {filteredChatList?.length === 0 && (
                              <div className="NoChatMessage">
                                <h3>No Conversations Found</h3>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="NoChatMessage">
                        <h3>No Chated Hostesses Found</h3>
                      </div>
                    )
                  )}
                </div>
              )}

              {IsHostess && (
                <div className="ProfileStatus">
                  {IsUploading ? (
                    <ContentLoader
                      speed={2}
                      width={800}
                      height={100}
                      viewBox="0 0 800 100"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <circle cx="50" cy="50" r="30" />
                      <rect x="100" y="25" rx="5" ry="5" width="100" height="15" />
                      <rect x="100" y="50" rx="5" ry="5" width="60" height="10" />
                      <rect x="200" y="25" rx="5" ry="5" width="100" height="15" />
                      <rect x="320" y="25" rx="5" ry="5" width="100" height="15" />
                      <rect x="450" y="25" rx="5" ry="5" width="100" height="15" />
                    </ContentLoader>
                  ) : (
                    AllChatedUser?.length > 0 ? (
                      <>
                        <h3>Chat List</h3>
                        <br />
                        <div className="ChatList">
                          <div className="ChatList-search">
                            <input
                              placeholder="Search Conversation"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <img src={serch} alt="Search" />
                          </div>
                          <br />
                          <br />
                          <div className="chat-container">
                            {filteredUsers?.length > 0 ? (
                              filteredUsers.map((item, index) => (
                                <div
                                  onClick={() => {
                                    OpenHostessChatModel(item);
                                  }}
                                  className="chat-div"
                                  key={index}
                                >
                                  <div className="chat-div-1">
                                    <div>
                                      <img
                                        src={item?.profilePicture ? item?.profilePicture : img1}
                                        alt="Profile"
                                      />
                                    </div>
                                    <div>
                                      <h3>{item?.name}</h3>
                                      <p>{item?.email}</p>
                                    </div>
                                  </div>
                                  <div className="chat-time">
                                    <h4>{item?.time || "9:00 PM"}</h4>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="NoChatMessage">
                                <h3>No Conversations Found</h3>
                              </div>
                            )}
                          </div>
                        </div>
                        <br />
                      </>
                    ) : (
                      <div className="NoChatMessage">
                        <h3>No Chated Users Found</h3>
                      </div>
                    )
                  )}
                </div>
              )}

            </>}

            {activeTab === 4 && <>
              <div className="ProfileStatus">
                <h3>My Reviews</h3>
                <br />
                {IsUploading ? (
                  <ContentLoader
                    speed={2}
                    width={800}
                    height={100}
                    viewBox="0 0 800 100"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <circle cx="50" cy="50" r="30" />
                    <rect x="100" y="25" rx="5" ry="5" width="100" height="15" />
                    <rect x="100" y="50" rx="5" ry="5" width="60" height="10" />
                    <rect x="200" y="25" rx="5" ry="5" width="100" height="15" />
                    <rect x="320" y="25" rx="5" ry="5" width="100" height="15" />
                    <rect x="450" y="25" rx="5" ry="5" width="100" height="15" />
                  </ContentLoader>
                ) : (
                  AllReview?.map((item, index) => (
                    <>
                      <div key={index} className="reviewcard">
                        <div>
                          <img src={pro} alt="Profile" />
                        </div>
                        <div>
                          <h6>{item?.User?.UserName}</h6>
                        </div>
                        <div>
                          <h6>{item?.Text}</h6>
                        </div>
                        <div className="str">
                          {Array(5)
                            ?.fill(0)
                            ?.map((_, i) => (
                              <i
                                key={i}
                                className={
                                  i < item?.Review
                                    ? "bi bi-star-fill"
                                    : "bi bi-star"
                                }
                              ></i>
                            ))}
                        </div>
                        <div>
                          <h5>{formatDateonly(item?.createdAt)}</h5>
                        </div>
                        <div>
                          <h4 onClick={() => DeleteReview(item?._id)}>
                            Delete Review
                          </h4>
                        </div>
                      </div>
                      <br />
                    </>
                  ))
                )}
                <br />
              </div>
            </>}
            {activeTab === 5 && <>
              <div className="ProfileStatus">
                <h3>Last views</h3>
                <br />
                {IsUploading ? (
                  <ContentLoader
                    speed={2}
                    width={800}
                    height={100}
                    viewBox="0 0 800 100"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <circle cx="50" cy="50" r="30" />
                    <rect x="100" y="25" rx="5" ry="5" width="100" height="15" />
                    <rect x="100" y="50" rx="5" ry="5" width="60" height="10" />
                    <rect x="200" y="25" rx="5" ry="5" width="100" height="15" />
                    <rect x="320" y="25" rx="5" ry="5" width="100" height="15" />
                    <rect x="450" y="25" rx="5" ry="5" width="100" height="15" />
                  </ContentLoader>
                ) : (
                  AllLastViews?.map((item, index) => (
                    <>
                      <div key={index} className="reviewcard">
                        <div>
                          <img src={pro} />
                        </div>
                        <div>
                          <h6>{item?.UserName}</h6>
                        </div>
                        <div>
                          <h5>{formatDateonly(item?.updatedAt)}</h5>
                        </div>
                        <div>
                          <h5>{formatTimeOnly(item?.updatedAt)}</h5>
                        </div>
                        <div>
                          <button
                            onClick={() => { OpenHostessChatModelfromlastView(item) }}
                          >Chat</button>
                        </div>
                      </div>
                      <br />
                    </>
                  ))
                )}
                <br />

              </div>
            </>}

            {activeTab === 6 && IsHostess &&
              <>
                <div className="ProfileStatus">
                  <h3>Settings</h3>
                </div>
                <br />
                <div className="PhotoGallery">
                  <h2>Profile Setting</h2>
                  <br />
                  <div className='ProfileSetting-div'>
                    <div className='ProfileSetting-icon'>
                      <img src={HostessProfile?.Gallary ? HostessProfile?.Gallary[0] : img} />
                      <h3>{HostessProfile?.UserName} </h3>
                    </div>
                    <button
                      onClick={() => Logout()}>
                      Logout
                    </button>
                  </div>
                  <br />
                </div>
                <br />
                <div className='PhotoGallery'>
                  <h2>Account</h2>
                  <br />

                  <div className='acc-div'>
                    <p>Full Name</p>
                    <h6>{HostessProfile?.UserName}</h6>
                  </div>
                  <br />

                  <div className='acc-div'>
                    <p>Mobile</p>
                    <h6>+91{HostessProfile?.Number}</h6>
                  </div>
                  <br />
                  <div className='acc-div'>
                    <p>Email</p>
                    <h6>{HostessProfile?.Email}</h6>
                  </div>

                </div>
                <br />
                <div className='PhotoGallery'>
                  <h2>Change Password</h2>
                  <br />
                  <div className='ChangePassword-div'>
                    <div className='ChangePassword-ips'>
                      <label>Current Password</label>
                      <input
                        placeholder="Current Password"
                        value={OldPassword}
                        onChange={(e) => { setOldPassword(e.target.value) }}
                      />
                    </div>
                    <div className='ChangePassword-ips'>
                      <label>New Password</label>
                      <input
                        placeholder="New Password"
                        value={NewPassword}
                        onChange={(e) => { setNewPassword(e.target.value) }}
                      />
                    </div>
                  </div>
                  <br />
                  <br />
                  <button onClick={() => HostessChangePassword()} className='save-chn'>Save Changes</button>

                </div>

                <br />
                <div className='PhotoGallery'>
                  <h2>Notification</h2>
                  <br />
                  <br />
                  <div className='Profilevisible'>
                    <div>
                      <h4>Profile visible</h4>
                      <h5>You can set-up who can able to view your profile.</h5>

                    </div>
                    <label class="switch">
                      <input type="checkbox" />
                      <span class="slider"></span>
                    </label>
                  </div>

                </div>
              </>
            }
            {activeTab === 6 && IsUser &&
              <>
                <div className="ProfileStatus">
                  <h3>Settings</h3>
                </div>
                <br />
                <div className="PhotoGallery">
                  <h2>Profile Setting</h2>
                  <br />
                  <div className='ProfileSetting-div'>
                    <div className='ProfileSetting-icon'>
                      <img src={img} />
                      <h3>{UserProfile?.UserName} </h3>
                    </div>
                    <button
                      onClick={() => Logout()}>
                      Logout
                    </button>
                  </div>
                  <br />
                </div>
                <br />
                <div className='PhotoGallery'>
                  <h2>Account</h2>
                  <br />

                  <div className='acc-div'>
                    <p>Full Name</p>
                    <h6>{UserProfile?.UserName}</h6>
                  </div>
                  <br />

                  <div className='acc-div'>
                    <p>Mobile</p>
                    <h6>+91{UserProfile?.Number}</h6>
                  </div>
                  <br />
                  <div className='acc-div'>
                    <p>Email</p>
                    <h6>{UserProfile?.Email}</h6>
                  </div>

                </div>
                <br />
                <div className='PhotoGallery'>
                  <h2>Change Password</h2>
                  <br />
                  <div className='ChangePassword-div'>
                    <div className='ChangePassword-ips'>
                      <label>Current Password</label>
                      <input
                        placeholder="Current Password"
                        value={OldPassword}
                        onChange={(e) => { setOldPassword(e.target.value) }}
                      />
                    </div>
                    <div className='ChangePassword-ips'>
                      <label>New Password</label>
                      <input
                        placeholder="New Password"
                        value={NewPassword}
                        onChange={(e) => { setNewPassword(e.target.value) }}
                      />
                    </div>
                  </div>
                  <br />
                  <br />
                  <button onClick={() => UserChangePassword()} className='save-chn'>Save Changes</button>

                </div>

                <br />
                <div className='PhotoGallery'>
                  <h2>Notification</h2>
                  <br />
                  <br />
                  <div className='Profilevisible'>
                    <div>
                      <h4>Profile visible</h4>
                      <h5>You can set-up who can able to view your profile.</h5>

                    </div>
                    <label class="switch">
                      <input type="checkbox" />
                      <span class="slider"></span>
                    </label>
                  </div>

                </div>
              </>

            }

            {activeTab === 7 && <>tab7</>}
            {activeTab === 8 && <><Shop /></>}

          </div>
        </div>
      </div >
      <UpdateProfileImageModal
        show={OpenUpdateProfileImageModal}
        onClose={CloseUpdateProfileImage}
        GetHostessProfile={GetHostessProfile}
      />
      <UpdateGallaryModal
        show={OpenUpdateGallaryModal}
        onClose={CloseUpdateGallary}
        GetHostessProfile={GetHostessProfile}
      />
      <UpdateAboutModal
        show={OpenUpdateAboutModal}
        onClose={CloseUpdateAbout}
        GetHostessProfile={GetHostessProfile}
        HostessProfile={HostessProfile}
      />
      <UpdateAvailableForModal
        show={OpenUpdateAvailableModal}
        onClose={CloseUpdateAvailable}
        GetHostessProfile={GetHostessProfile}
        HostessProfile={HostessProfile}
      />
      <UpdatePersonalDetailModal
        show={OpenUpdatePersonalModal}
        onClose={CloseUpdatePersonal}
        GetHostessProfile={GetHostessProfile}
        HostessProfile={HostessProfile}
      />
      <UpdateSocialMedialinkModal
        show={OpenUpdateSocialmediaModal}
        onClose={CloseUpdateSocialmedia}
        GetHostessProfile={GetHostessProfile}
        HostessProfile={HostessProfile}
      />
      <UpdateAvailableModal
        show={OpenAvailableModel}
        onClose={CloseAvailablePersonal}
        GetHostessProfile={GetHostessProfile}
        HostessProfile={HostessProfile}
      />
      <UpdateUserProfileModal
        show={OpenUpdateUserProfileImageModal}
        onClose={CloseUpdateUserProfileImage}
        GetHostessProfile={GetUserProfile}
      />
      <UpdateUserModel
        show={UpdateModel}
        onClose={CloseUpdatModel}
        GetHostessProfile={GetUserProfile}
        HostessProfile={UserProfile}
      />
      <UpdateUserSocialMedialinkModel
        show={UpdateUserSocialModel}
        onClose={CloseUpdateUserSocialModel}
        GetHostessProfile={GetUserProfile}
        HostessProfile={UserProfile}
      />
      <UserChatModal isOpen={UserChatmodel} toggleModal={CloseUserChatModel} Host={SelectedHost} />
      <HostessChatModel isOpen={HostessChatmodel} toggleModal={CloseHostessChatModel} User={SelectedUser} />
      <Footer />
    </>
  );
}

export default Profile;
